/**
 * src/components/onboarding/employeeGuideData.js
 * Sample employee data for the Employee Lifecycle guide (Part 2).
 * Used by both EmployeeLifecycleWizard and initialState.
 */

export const SAMPLE_EMPLOYEES = [
  {
    id: 'emp-example-1',
    name: 'Maria Chen',
    email: 'maria.chen@example.com',
    phone: '+45 22 33 44 55',
    department: 'Engineering',
    team: 'Platform',
    jobTitle: 'Senior Developer',
    manager: 'user-admin',
    employmentType: 'full-time',
    startDate: '2025-06-15T00:00:00Z',
    endDate: null,
    status: 'active',
    linkedUserId: null,
    emergencyContact: 'Li Chen, +45 33 44 55 66',
    notes: 'Joined from Copenhagen office. Lead on infrastructure migration.',
    createdAt: '2025-06-15T08:00:00Z',
    updatedAt: '2026-03-10T14:30:00Z',
    updatedBy: 'user-admin',
    roles: [
      { id: 'role-ex-1', name: 'Senior Developer' },
      { id: 'role-ex-2', name: 'Tech Lead' },
    ],
    jmlProcesses: [
      {
        id: 'jml-ex-join-1',
        type: 'join',
        status: 'completed',
        startedAt: '2025-06-15T08:00:00Z',
        startedBy: 'user-admin',
        completedAt: '2025-06-27T16:00:00Z',
        checklist: [
          {
            key: 'contract-signed',
            label: 'Employment contract signed',
            completed: true,
            completedAt: '2025-06-15T09:00:00Z',
            completedBy: 'user-admin',
            notes: 'Signed before start date',
          },
          {
            key: 'nda-signed',
            label: 'NDA / Confidentiality agreement signed',
            completed: true,
            completedAt: '2025-06-15T09:15:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'screening-complete',
            label: 'Pre-employment screening complete',
            completed: true,
            completedAt: '2025-06-10T12:00:00Z',
            completedBy: 'user-admin',
            notes: 'Background check passed',
          },
          {
            key: 'it-accounts',
            label: 'IT accounts provisioned',
            completed: true,
            completedAt: '2025-06-16T10:00:00Z',
            completedBy: 'user-admin',
            notes: 'GitHub, Slack, email',
          },
          {
            key: 'assets-issued',
            label: 'Assets issued (laptop, badge, phone, etc.)',
            completed: true,
            completedAt: '2025-06-16T11:00:00Z',
            completedBy: 'user-admin',
            notes: 'MacBook + badge issued',
          },
          {
            key: 'security-training',
            label: 'Security awareness training assigned',
            completed: true,
            completedAt: '2025-06-20T15:00:00Z',
            completedBy: 'user-admin',
            notes: 'Completed online course',
          },
          {
            key: 'policies-acknowledged',
            label: 'Key policies acknowledged',
            completed: true,
            completedAt: '2025-06-22T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'manager-intro',
            label: 'Manager introduction and onboarding plan',
            completed: true,
            completedAt: '2025-06-15T14:00:00Z',
            completedBy: 'user-admin',
            notes: '30-60-90 day plan set',
          },
          {
            key: 'acceptable-use',
            label: 'Acceptable use policy signed',
            completed: true,
            completedAt: '2025-06-22T10:30:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
        ],
      },
    ],
    assets: [
      {
        id: 'asset-ex-1',
        name: 'MacBook Pro 16\u2033',
        type: 'laptop',
        serialNumber: 'FVFHJ3M7Q6',
        issuedAt: '2025-06-16T11:00:00Z',
        returnedAt: null,
        condition: null,
      },
      {
        id: 'asset-ex-2',
        name: 'Office Badge #1042',
        type: 'badge',
        serialNumber: 'BADGE-1042',
        issuedAt: '2025-06-16T11:15:00Z',
        returnedAt: null,
        condition: null,
      },
      {
        id: 'asset-ex-3',
        name: 'YubiKey 5C NFC',
        type: 'other',
        serialNumber: 'YK-9928174',
        issuedAt: '2025-06-16T11:20:00Z',
        returnedAt: null,
        condition: null,
      },
    ],
    documentAcknowledgements: [
      {
        id: 'ack-ex-1',
        documentId: 'doc1',
        documentTitle: 'Information Security Policy',
        version: 2.1,
        acknowledgedAt: '2025-06-22T10:00:00Z',
        recordedBy: 'user-admin',
      },
      {
        id: 'ack-ex-2',
        documentId: 'doc2',
        documentTitle: 'Access Control Procedure',
        version: 1.4,
        acknowledgedAt: '2025-06-22T10:10:00Z',
        recordedBy: 'user-admin',
      },
      {
        id: 'ack-ex-3',
        documentId: 'doc3',
        documentTitle: 'Incident Response Plan',
        version: 3.0,
        acknowledgedAt: '2025-06-22T10:20:00Z',
        recordedBy: 'user-admin',
      },
    ],
    sensitiveDocuments: [
      {
        id: 'sensdoc-ex-1',
        label: 'Criminal record check 2025',
        type: 'criminal-record',
        status: 'deleted',
        requestedAt: '2025-06-10T08:00:00Z',
        requestedBy: 'user-admin',
        submittedAt: '2025-06-12T14:00:00Z',
        readAt: '2025-06-13T09:00:00Z',
        readBy: 'user-admin',
        acceptedAt: '2025-06-13T09:30:00Z',
        acceptedBy: 'user-admin',
        deletedAt: '2025-06-13T10:00:00Z',
      },
      {
        id: 'sensdoc-ex-2',
        label: 'Passport copy',
        type: 'id-document',
        status: 'deleted',
        requestedAt: '2025-06-10T08:05:00Z',
        requestedBy: 'user-admin',
        submittedAt: '2025-06-11T16:00:00Z',
        readAt: '2025-06-12T10:00:00Z',
        readBy: 'user-admin',
        acceptedAt: '2025-06-12T10:15:00Z',
        acceptedBy: 'user-admin',
        deletedAt: '2025-06-12T10:30:00Z',
      },
    ],
    evaluations: {
      'eval-crit-ex-1': {
        score: 4,
        target: 5,
        note: 'Strong security fundamentals, continuing to improve.',
        updatedAt: '2026-03-10T14:00:00Z',
        history: [
          { score: 3, target: 5, changedAt: '2025-09-15T10:00:00Z', changedBy: 'user-admin' },
        ],
        roleScores: {
          'Tech Lead': {
            score: 4,
            target: 5,
            note: 'Good at enforcing secure coding practices.',
            updatedAt: '2026-03-10T14:00:00Z',
            history: [],
          },
        },
      },
      'eval-crit-ex-2': {
        score: 5,
        target: 5,
        note: 'Excellent \u2014 consistently follows all procedures.',
        updatedAt: '2026-03-10T14:10:00Z',
        history: [
          { score: 4, target: 5, changedAt: '2025-09-15T10:30:00Z', changedBy: 'user-admin' },
        ],
        roleScores: {},
      },
      'eval-crit-ex-3': {
        score: 4,
        target: 4,
        note: 'Completed all required training modules.',
        updatedAt: '2026-03-10T14:20:00Z',
        history: [],
        roleScores: {},
      },
    },
    comments: [
      {
        id: 'cmt-ex-1',
        text: 'Onboarding went smoothly. Maria hit the ground running \u2014 already contributing to sprint work in week 2.',
        authorId: 'user-admin',
        createdAt: '2025-07-01T09:00:00Z',
        directedTo: 'user-admin',
        fromPortal: false,
      },
      {
        id: 'cmt-ex-2',
        text: 'Promoted to Tech Lead role after strong Q3 performance.',
        authorId: 'user-admin',
        createdAt: '2025-10-01T11:00:00Z',
        directedTo: 'user-admin',
        fromPortal: false,
      },
    ],
    infoItems: [],
  },
  {
    id: 'emp-example-2',
    name: 'Thomas Andersen',
    email: 'thomas.andersen@example.com',
    phone: '+45 50 60 70 80',
    department: 'Operations',
    team: 'Infrastructure',
    jobTitle: 'Systems Administrator',
    manager: 'user-admin',
    employmentType: 'full-time',
    startDate: '2024-03-01T00:00:00Z',
    endDate: null,
    status: 'moving',
    linkedUserId: null,
    emergencyContact: 'Lise Andersen, +45 61 72 83 94',
    notes: 'Transferring from Operations \u2192 Security team effective April 2026.',
    createdAt: '2024-03-01T08:00:00Z',
    updatedAt: '2026-03-20T10:00:00Z',
    updatedBy: 'user-admin',
    roles: [{ id: 'role-ex-3', name: 'Systems Administrator' }],
    jmlProcesses: [
      {
        id: 'jml-ex-join-2',
        type: 'join',
        status: 'completed',
        startedAt: '2024-03-01T08:00:00Z',
        startedBy: 'user-admin',
        completedAt: '2024-03-15T16:00:00Z',
        checklist: [
          {
            key: 'contract-signed',
            label: 'Employment contract signed',
            completed: true,
            completedAt: '2024-03-01T09:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'nda-signed',
            label: 'NDA / Confidentiality agreement signed',
            completed: true,
            completedAt: '2024-03-01T09:30:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'screening-complete',
            label: 'Pre-employment screening complete',
            completed: true,
            completedAt: '2024-02-20T12:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'it-accounts',
            label: 'IT accounts provisioned',
            completed: true,
            completedAt: '2024-03-01T14:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'assets-issued',
            label: 'Assets issued (laptop, badge, phone, etc.)',
            completed: true,
            completedAt: '2024-03-01T15:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'security-training',
            label: 'Security awareness training assigned',
            completed: true,
            completedAt: '2024-03-10T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'policies-acknowledged',
            label: 'Key policies acknowledged',
            completed: true,
            completedAt: '2024-03-12T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'manager-intro',
            label: 'Manager introduction and onboarding plan',
            completed: true,
            completedAt: '2024-03-01T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'acceptable-use',
            label: 'Acceptable use policy signed',
            completed: true,
            completedAt: '2024-03-12T10:30:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
        ],
      },
      {
        id: 'jml-ex-move-1',
        type: 'move',
        status: 'active',
        startedAt: '2026-03-20T10:00:00Z',
        startedBy: 'user-admin',
        completedAt: null,
        checklist: [
          {
            key: 'access-review',
            label: 'Access rights reviewed and updated',
            completed: true,
            completedAt: '2026-03-21T09:00:00Z',
            completedBy: 'user-admin',
            notes: 'Ops systems revoked, Security tools granted',
          },
          {
            key: 'asset-reassignment',
            label: 'Assets reassigned if needed',
            completed: true,
            completedAt: '2026-03-21T10:00:00Z',
            completedBy: 'user-admin',
            notes: 'Keeping current laptop',
          },
          {
            key: 'new-manager',
            label: 'New manager assigned',
            completed: true,
            completedAt: '2026-03-20T11:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'role-update',
            label: 'Role and responsibilities updated',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
          {
            key: 'training-review',
            label: 'Training requirements reviewed',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
          {
            key: 'data-handover',
            label: 'Data and knowledge handover complete',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
        ],
      },
    ],
    assets: [
      {
        id: 'asset-ex-4',
        name: 'ThinkPad X1 Carbon',
        type: 'laptop',
        serialNumber: 'PF3ABCDE',
        issuedAt: '2024-03-01T15:00:00Z',
        returnedAt: null,
        condition: null,
      },
      {
        id: 'asset-ex-5',
        name: 'Office Badge #0871',
        type: 'badge',
        serialNumber: 'BADGE-0871',
        issuedAt: '2024-03-01T15:10:00Z',
        returnedAt: null,
        condition: null,
      },
    ],
    documentAcknowledgements: [
      {
        id: 'ack-ex-4',
        documentId: 'doc1',
        documentTitle: 'Information Security Policy',
        version: 2.1,
        acknowledgedAt: '2024-03-12T10:00:00Z',
        recordedBy: 'user-admin',
      },
    ],
    sensitiveDocuments: [],
    evaluations: {
      'eval-crit-ex-1': {
        score: 3,
        target: 4,
        note: 'Solid understanding \u2014 needs deeper ISO 27001 knowledge for Security role.',
        updatedAt: '2026-03-01T10:00:00Z',
        history: [],
        roleScores: {},
      },
      'eval-crit-ex-2': {
        score: 4,
        target: 5,
        note: 'Good adherence to change-management procedures.',
        updatedAt: '2026-03-01T10:30:00Z',
        history: [],
        roleScores: {},
      },
    },
    comments: [
      {
        id: 'cmt-ex-3',
        text: 'Thomas expressed interest in moving to the Security team. Scheduling knowledge-transfer sessions with Ops.',
        authorId: 'user-admin',
        createdAt: '2026-03-15T09:00:00Z',
        directedTo: 'user-admin',
        fromPortal: false,
      },
    ],
    infoItems: [],
  },
  {
    id: 'emp-example-3',
    name: 'Sarah Olsen',
    email: 'sarah.olsen@example.com',
    phone: '+45 71 82 93 04',
    department: 'Finance',
    team: 'Accounting',
    jobTitle: 'Financial Controller',
    manager: 'user-admin',
    employmentType: 'full-time',
    startDate: '2023-01-10T00:00:00Z',
    endDate: '2026-04-30T00:00:00Z',
    status: 'offboarding',
    linkedUserId: null,
    emergencyContact: 'Peter Olsen, +45 82 93 04 15',
    notes: 'Last day 30 April 2026. Handover to Jakob Nielsen.',
    createdAt: '2023-01-10T08:00:00Z',
    updatedAt: '2026-03-25T16:00:00Z',
    updatedBy: 'user-admin',
    roles: [{ id: 'role-ex-4', name: 'Financial Controller' }],
    jmlProcesses: [
      {
        id: 'jml-ex-join-3',
        type: 'join',
        status: 'completed',
        startedAt: '2023-01-10T08:00:00Z',
        startedBy: 'user-admin',
        completedAt: '2023-01-24T16:00:00Z',
        checklist: [
          {
            key: 'contract-signed',
            label: 'Employment contract signed',
            completed: true,
            completedAt: '2023-01-10T09:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'nda-signed',
            label: 'NDA / Confidentiality agreement signed',
            completed: true,
            completedAt: '2023-01-10T09:15:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'screening-complete',
            label: 'Pre-employment screening complete',
            completed: true,
            completedAt: '2023-01-05T12:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'it-accounts',
            label: 'IT accounts provisioned',
            completed: true,
            completedAt: '2023-01-10T14:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'assets-issued',
            label: 'Assets issued (laptop, badge, phone, etc.)',
            completed: true,
            completedAt: '2023-01-10T15:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'security-training',
            label: 'Security awareness training assigned',
            completed: true,
            completedAt: '2023-01-18T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'policies-acknowledged',
            label: 'Key policies acknowledged',
            completed: true,
            completedAt: '2023-01-20T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'manager-intro',
            label: 'Manager introduction and onboarding plan',
            completed: true,
            completedAt: '2023-01-10T10:00:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
          {
            key: 'acceptable-use',
            label: 'Acceptable use policy signed',
            completed: true,
            completedAt: '2023-01-20T10:30:00Z',
            completedBy: 'user-admin',
            notes: '',
          },
        ],
      },
      {
        id: 'jml-ex-leave-1',
        type: 'leave',
        status: 'active',
        startedAt: '2026-03-25T09:00:00Z',
        startedBy: 'user-admin',
        completedAt: null,
        checklist: [
          {
            key: 'exit-interview',
            label: 'Exit interview conducted',
            completed: true,
            completedAt: '2026-03-25T14:00:00Z',
            completedBy: 'user-admin',
            notes: 'Leaving for personal reasons \u2014 positive exit',
          },
          {
            key: 'asset-return',
            label: 'All assets returned and verified',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: 'Scheduled for last day',
          },
          {
            key: 'access-revoked',
            label: 'All system access revoked',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
          {
            key: 'email-forwarding',
            label: 'Email forwarding / delegation set up',
            completed: true,
            completedAt: '2026-03-26T10:00:00Z',
            completedBy: 'user-admin',
            notes: 'Forwarding to jakob.nielsen@example.com',
          },
          {
            key: 'knowledge-transfer',
            label: 'Knowledge transfer complete',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: 'Sessions scheduled through April',
          },
          {
            key: 'legal-obligations',
            label: 'Post-employment legal obligations communicated (NDA, non-compete)',
            completed: true,
            completedAt: '2026-03-25T15:00:00Z',
            completedBy: 'user-admin',
            notes: 'NDA remains in effect for 2 years',
          },
          {
            key: 'final-payroll',
            label: 'Final payroll and benefits confirmed',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
          {
            key: 'data-backup',
            label: 'Personal data removed / archived per policy',
            completed: false,
            completedAt: null,
            completedBy: null,
            notes: '',
          },
        ],
      },
    ],
    assets: [
      {
        id: 'asset-ex-6',
        name: 'Dell Latitude 5540',
        type: 'laptop',
        serialNumber: 'SVC-DL5540-227',
        issuedAt: '2023-01-10T15:00:00Z',
        returnedAt: null,
        condition: null,
      },
      {
        id: 'asset-ex-7',
        name: 'Office Badge #0612',
        type: 'badge',
        serialNumber: 'BADGE-0612',
        issuedAt: '2023-01-10T15:10:00Z',
        returnedAt: null,
        condition: null,
      },
      {
        id: 'asset-ex-8',
        name: 'iPhone 14 (company)',
        type: 'phone',
        serialNumber: 'DNRXQ43MHG',
        issuedAt: '2023-01-10T15:15:00Z',
        returnedAt: null,
        condition: null,
      },
    ],
    documentAcknowledgements: [
      {
        id: 'ack-ex-5',
        documentId: 'doc1',
        documentTitle: 'Information Security Policy',
        version: 2.1,
        acknowledgedAt: '2025-01-10T10:00:00Z',
        recordedBy: 'user-admin',
      },
      {
        id: 'ack-ex-6',
        documentId: 'doc3',
        documentTitle: 'Incident Response Plan',
        version: 3.0,
        acknowledgedAt: '2025-01-10T10:15:00Z',
        recordedBy: 'user-admin',
      },
    ],
    sensitiveDocuments: [
      {
        id: 'sensdoc-ex-3',
        label: 'Criminal record check 2023',
        type: 'criminal-record',
        status: 'deleted',
        requestedAt: '2023-01-05T08:00:00Z',
        requestedBy: 'user-admin',
        submittedAt: '2023-01-08T10:00:00Z',
        readAt: '2023-01-09T09:00:00Z',
        readBy: 'user-admin',
        acceptedAt: '2023-01-09T09:30:00Z',
        acceptedBy: 'user-admin',
        deletedAt: '2023-01-09T10:00:00Z',
      },
    ],
    evaluations: {
      'eval-crit-ex-2': {
        score: 5,
        target: 5,
        note: 'Exemplary process compliance \u2014 always follows financial controls.',
        updatedAt: '2026-01-15T10:00:00Z',
        history: [
          { score: 4, target: 5, changedAt: '2025-01-15T10:00:00Z', changedBy: 'user-admin' },
        ],
        roleScores: {},
      },
    },
    comments: [
      {
        id: 'cmt-ex-4',
        text: 'Resignation received. Last working day 30 April. Handover plan created with Jakob Nielsen.',
        authorId: 'user-admin',
        createdAt: '2026-03-20T09:00:00Z',
        directedTo: 'user-admin',
        fromPortal: false,
      },
      {
        id: 'cmt-ex-5',
        text: 'Thank you for three great years. Happy to help with any questions after I leave.',
        authorId: 'user-admin',
        createdAt: '2026-03-25T16:00:00Z',
        directedTo: 'user-admin',
        fromPortal: true,
      },
    ],
    infoItems: [],
  },
];

export const SAMPLE_EVALUATION_CRITERIA = [
  {
    id: 'eval-crit-ex-1',
    name: 'Security Awareness',
    description:
      'Understanding of information security principles, threat recognition, and incident reporting.',
    scaleMax: 5,
    scaleLabels: ['None', 'Basic', 'Intermediate', 'Advanced', 'Expert'],
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'eval-crit-ex-2',
    name: 'Policy Compliance',
    description:
      'Adherence to internal policies, procedures, and regulatory requirements in daily work.',
    scaleMax: 5,
    scaleLabels: ['Non-compliant', 'Partial', 'Adequate', 'Strong', 'Exemplary'],
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'eval-crit-ex-3',
    name: 'Training Completion',
    description:
      'Completion of required security awareness training, certifications, and ongoing education.',
    scaleMax: 4,
    scaleLabels: ['Not started', 'In progress', 'Core complete', 'All complete'],
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
];
